import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Header() {

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById("navbarSupportedContent");

      if (navbar && navbar.classList.contains("show")) {
        navbar.classList.remove("show");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMenu = () => {
    const navbar = document.getElementById("navbarSupportedContent");
    if (navbar) {
      navbar.classList.remove("show");
    }
  };

  return (
    <header className="header">
      <div className="container-header">

        <nav className="navbar navbar-expand-lg navbar-light">

          {/* ✅ MOBILE TOP BAR */}
          <div className="d-flex w-100 align-items-center d-lg-none">

            {/* MOBILE LOGO */}
            <Link className="navbar-brand" to="/">
              <img
                src="/assets/website-images/logo_festivo.png"
                alt="logo"
                className="logo img-fluid"
              />
            </Link>

            {/* TOGGLE */}
            <button
              className="navbar-toggler ms-auto"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
            >
              <i className="fa-solid fa-bars"></i>
            </button>

          </div>

          {/* DESKTOP TOGGLE (hidden but required) */}
          <button
            className="navbar-toggler ms-auto d-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
          >
            <i className="fa-solid fa-bars"></i>
          </button>

          {/* MENU WRAPPER */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">

            <div className="row w-100 align-items-center p-0 m-0">

              {/* ✅ DESKTOP LOGO */}
              <div className="col-lg-3 col-12 d-none d-lg-block">
                <Link className="navbar-brand" to="/">
                  <img
                    src="/assets/website-images/logo_festivo.png"
                    alt="logo"
                    className="logo img-fluid"
                  />
                </Link>
              </div>

              {/* MENU */}
              <div className="col-lg-6 col-12 d-flex justify-content-center align-items-center p-0 m-0">
                <ul className="navbar-nav d-flex flex-lg-row flex-column text-center">

                  <li className="nav-item">
                    <Link className="nav-link" to="/" onClick={closeMenu}>Home</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/about" onClick={closeMenu}>About Us</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/products" onClick={closeMenu}>Products</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/contacts" onClick={closeMenu}>Contact Us</Link>
                  </li>

                  {/* MOBILE ONLY LOCATION */}
                  <li className="nav-item d-lg-none">
                    <Link className="nav-link" to="/locations" onClick={closeMenu}>
                      Locations
                    </Link>
                  </li>

                </ul>
              </div>

              {/* CONTACT */}
              <div className="col-lg-3 col-12 d-flex justify-content-lg-end justify-content-center align-items-center mt-2 mt-lg-0">
                <div className="last_list">
                  <Link className="contact_us" to="/locations" onClick={closeMenu}>
                    Locations <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </div>
              </div>

            </div>

          </div>

        </nav>

      </div>
    </header>
  );
}

export default Header;